import { Injectable } from '@angular/core';
// import { Http, RequestOptions, Headers, ResponseContentType } from '@angular/http';
import { environment } from '../../environments/environment';
import { Token } from '../manager/token';
import { Router } from '@angular/router';
// import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject, Subscription } from 'rxjs';
import { map } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { AES, enc, PBKDF2, algo, mode, pad } from 'crypto-js';
import * as moment from 'moment';

@Injectable({
  providedIn: 'root'
})


export class CommonService {
  // default values to encrypt password
  TokenCls;
  ITERATION = 1000;
  SALT = enc.Base64.parse('SXZhbiBNZWR2ZWRldg==');
  KEYSIZE = 256 / 32 + 128 / 32;
  hasherAlgorythm = algo.SHA1;

  private actionTrigger = new Subject<void>();

  action$ = this.actionTrigger.asObservable();
  private subscription: Subscription | null = null;
  private lastCallback: ((value: any) => void) | null = null; // Store callback

  constructor(private http: HttpClient, private router: Router) {
    this.TokenCls = new Token(this.router);
  }

  // function for encrypt password
  encryptData(data, encryptionKey: string = null) {
    const keyAndIv = PBKDF2(enc.Utf8.parse(encryptionKey || environment.Encryptionkey), this.SALT,
      { keySize: this.KEYSIZE, iterations: this.ITERATION, hasher: this.hasherAlgorythm });
    const hexKeyAndIv = enc.Hex.stringify(keyAndIv);
    return AES.encrypt(enc.Utf16LE.parse(data), enc.Hex.parse(hexKeyAndIv.substring(0, 64)),
      { iv: enc.Hex.parse(hexKeyAndIv.substring(64, hexKeyAndIv.length)) }).toString();
  }

  static decryptData(ciphertext: string, decryptionkey: string = null): string {
    // Use provided key or fallback to environment key
    const key = decryptionkey || environment.Encryptionkey;
    //const key = "GeBBS1@R";
    // Derive key and IV using PBKDF2
    const keyAndIv = PBKDF2(enc.Utf8.parse(key), enc.Base64.parse('SXZhbiBNZWR2ZWRldg=='), {
      keySize: 256 / 32 + 128 / 32,
      iterations: 1000,
      hasher: algo.SHA1
    });

    // Convert to hex string
    const hexKeyAndIv = enc.Hex.stringify(keyAndIv);

    // Extract key (first 64 hex chars = 32 bytes) and IV (rest = 16 bytes)
    const keyHex = hexKeyAndIv.substring(0, 64);
    const ivHex = hexKeyAndIv.substring(64);

    // Decrypt
    const decrypted = AES.decrypt(ciphertext, enc.Hex.parse(keyHex), {
      iv: enc.Hex.parse(ivHex),
      mode: mode.CBC,
      padding: pad.Pkcs7
    });

    // Convert back to UTF-16LE string (matches the Utf16LE.parse used in encrypt)
    return decrypted.toString(enc.Utf16LE)
  }


  GetClientList(formbody): any {
    return this.http.get(environment.ApiUrl + '/api/client-lookup/' + formbody);
  }

  getUserURILookup(): any {
    return this.http.get(environment.ApiUrl + '/api/user-url-lookup')
    ////return  this.http.get(environment.ApiUrl + '/api/user-url-lookup')

    // return abc.Data

    //  Observable.create(observer => {
    //  })
  }

  GetReferenceFile(filename: any): any {
    return this.http.post(environment.FileApiUrl + '/api/approval-file-download', { Reference_File_Name: filename }, { responseType: 'blob' })
      .pipe(map(res => {
        return {
          filename: filename,
          data: res
        };
      }));

  }

  // For search data through input use this common function
  // use have to pass 1) Array List 2) key which you want filter 3) event
  filterListOfData(arrayList, key, searchText) {
    // console.log('matchInbox : ', searchText);
    arrayList.filter((element) => {
      var result = element[key].toUpperCase().indexOf(searchText.target.value.toUpperCase());
      if (result !== -1) {
        element.show = true;
      }
      else {
        element.show = false;
      }
      // console.log('result : ', result, element)
    })
  }

  // For restrict Input Fields special characters

  /**
   * Getting 3 parameter from input
   * @param event keypress Event
   * @param formControlName Input FormControlName
   * @param formName FormGroup FormName
  */

  checkIsSpecialCharacter(event: any, formControlName?: string, formGroup?: any) {
    let isValid = this.restrictInputFields(event, formControlName, formGroup);

    // Agar invalid hai to loop ki zarurat nahi
    if (!isValid && event.target.value !== '') {
      this.restrictInputFields(event, formControlName, formGroup);
    }
  }

  restrictInputFields(event: any, formControlName?: string, formGroup?: any): boolean {
    // Regex: agar starting me ek ya multiple special characters hain
    const format = /^[ `~!@#$%^&*()+\-_=\[\]{};':"\\|,.<>\/?]+/;

    if (!format.test(event.target.value)) {
      // ✅ valid (starting me special char nahi hai)
      return true;
    } else {
      // ❌ starting ke sare special chars ek saath remove karo
      event.target.value = event.target.value.replace(
        /^[ `~!@#$%^&*()+\-_=\[\]{};':"\\|,.<>\/?]+/g,
        ''
      );

      // FormControl update karo agar diya gaya hai
      if (formControlName && formGroup) {
        formGroup.patchValue({ [formControlName]: event.target.value });
      }

      return false;
    }
  }

  // allow-only-two-digits-after-decimal-in-javascript
  formatDecimal(event) {
    let val = event.target.value;
    if ((val).toString().match(/\d+\.\d{2}/) != null) {
      return event.target.value = (val).toString().match(/\d+\.\d{2}/)[0];
    }
  }



  //#region for formcontrol form special character
  // check special character, whitespace in notes textarea
  isSpecialCharactersForForm(formControlName?: string, formName?: any) {
    let notesValue = this.getNotesValue(formControlName, formName);

    // Continue looping until the input is valid
    while (!this.removeSpecialCharacters(notesValue, formControlName, formName)) {
      if (this.removeSpecialCharacters(notesValue, formControlName, formName) || notesValue === '') {
        formName.get('Notes').setValue(notesValue);
        break;
      }
      notesValue = this.getNotesValue(formControlName, formName); // Update notesValue for the next iteration
    }
  }

  removeSpecialCharacters(textValue: string, formControlName?: string, formName?: any): boolean {
    const format = /^[^ `~!@#$%^&*()+\-_=\[\]{};':"\\|,.<>\/?]+/;

    if (format.test(textValue)) {
      // Input is valid
      return true;
    } else {
      // Input is invalid; remove invalid characters and update Notes value
      textValue = textValue.replace(/^[ `~!@#$%^&*()+\-_=\[\]{};':"\\|,.<>\/?]/gi, '');
      formName.get(formControlName).setValue(textValue);
      return false;
    }
  }

  getNotesValue(formControlName: string, formName?: any): string {
    return formName.get(formControlName).value;
  }
  //#endregion for formcontrol form special character


  // Helper function to format and compare dates
  formatAndCompareDates(fromDate: any, toDate: any): { validFromDate: boolean, validToDate: boolean } {
    if (!fromDate || !toDate) return { validFromDate: true, validToDate: true };  // Avoid validation if either date is not set

    let startDate = moment(fromDate).format('YYYY-MM-DD');
    let endDate = moment(toDate).format('YYYY-MM-DD');
    let startTime = startDate + " " + "00:00:00";
    let endTime = endDate + " " + "23:59:59";

    startTime = moment(startTime).format('YYYY-MM-DDTHH:mm');
    endTime = moment(endTime).format('YYYY-MM-DDTHH:mm');

    // Validate the date range
    const validFromDate = startTime < endTime;  // If FromDate is earlier than ToDate
    const validToDate = endTime > startTime;  // If ToDate is later than FromDate

    return { validFromDate, validToDate };
  }

  // uppercaseStrings
  upperCaseStrings(data) {
    const uppercased = data.map(obj =>
      Object.keys(obj).reduce((acc, key) => {
        const value = obj[key];
        acc[key] = typeof value === 'string' ? value.toUpperCase() : value;
        return acc;
      }, {} as Record<string, any>)
    );
    return uppercased;
  }


  // Start Agent screen combine #67373
  // 🔁 Subscribe with a callback (from the component)
  subscribeToAction(callback: (value: any) => void) {
    this.lastCallback = callback;

    if (!this.subscription || this.subscription.closed) {
      console.log("Subscribing to action$");
      this.subscription = this.action$.subscribe(callback);
    }
  }

  // ✅ Manually check if the subscription is closed
  isSubscriptionClosed(): boolean {
    return this.subscription?.closed ?? true;
  }

  // 🧹 Optional manual unsubscribe
  unsubscribe() {
    this.subscription?.unsubscribe();
  }

  // 🛠️ Check and reinitialize manually (if needed)
  emitAction() {
    if (this.isSubscriptionClosed()) {
      console.log("Subscription is closed.");
      this.reinitializeStream();
    } else {
      console.log("Still subscribed.");
    }

    this.actionTrigger.next(); // You can pass value here if needed
  }

  // ♻️ Recreate Subject, Observable and Resubscribe with last callback
  private reinitializeStream() {
    console.log("Reinitializing stream...");

    this.actionTrigger = new Subject<any>();
    this.action$ = this.actionTrigger.asObservable();

    if (this.lastCallback) {
      this.subscription = this.action$.subscribe(this.lastCallback);
    } else {
      console.warn("No callback available to re-subscribe.");
    }
  }
  // End Agent screen combine #67373

compareDate_FromTO(fromDate: any,toDate: any): boolean {

  // If either date is missing we consider it invalid (no comparison possible)
  if (!fromDate || !toDate) {
    return false;
  }

  // Format dates consistently as date-only strings
  const formattedFrom = moment(fromDate).format('YYYY-MM-DD');
  const formattedTo = moment(toDate).format('YYYY-MM-DD');

  // Valid when "from" is the same day or before "to".
  // previous implementation inverted the logic and returned true when the
  // from-date was later than the to-date which caused validation to always
  // pass.  This reverted behaviour is the root cause of the reported
  // "validation of fromdate not working" issue.
  if (formattedFrom <= formattedTo) {
    return true;
  }

  return false;
}
  
}


// for iAgent page fixedvalue
export enum FixedValue {
  FixedValue_0 = '0',
  FixedValue_currentdate = 'current date',
  FixedValue_Multi = 'multi',
  Fixed_CPT = 'CPT',
  Fixed_PPOPOS = 'PPO/POS',
  Fixed_PPO = 'PPO',
  Fixed_POS = 'POS'
}

// for iAgent page scnario type of
export enum CheckTypeOf {
  String = 'string',
  Number = 'number',
}
